import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { IconModule } from '../icon/icon.module';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [BreadcrumbsComponent],
  imports: [CommonModule, IconModule, RouterModule, TranslocoModule],
  exports: [BreadcrumbsComponent],
})
export class BreadcrumbsModule {}
